var render = function () {
  var _vm$state$form$title, _vm$state, _vm$state$form;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "ChatroomList",
      "extra-items": _vm.isEdit ? [(_vm$state$form$title = (_vm$state = _vm.state) === null || _vm$state === void 0 ? void 0 : (_vm$state$form = _vm$state.form) === null || _vm$state$form === void 0 ? void 0 : _vm$state$form.title) !== null && _vm$state$form$title !== void 0 ? _vm$state$form$title : '', '聊天室編輯'] : ['新增聊天室']
    }
  })], 1)]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.title))])])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('section', {
    staticClass: "row mb-8"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "標題",
      "label-for": "title"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "title",
      "type": "text",
      "state": _vm.v$.form.title.$error ? false : null
    },
    model: {
      value: _vm.state.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "title", $$v);
      },
      expression: "state.form.title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.title.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _vm.isEdit ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "聊天室來源",
      "label-for": "source_type"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "source_type",
      "type": "text"
    },
    model: {
      value: _vm.state.form.source_type,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "source_type", $$v);
      },
      expression: "state.form.source_type"
    }
  })], 1) : _vm._e(), _vm.isEdit ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "來源ID",
      "label-for": "source_id"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "source_id",
      "type": "number"
    },
    model: {
      value: _vm.state.form.source_id,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "source_id", $$v);
      },
      expression: "state.form.source_id"
    }
  })], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否啟用",
      "label-for": "is_enabled"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "name": "is_enabled",
      "value": 1,
      "unchecked-value": 0
    },
    model: {
      value: _vm.state.form.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "is_enabled", $$v);
      },
      expression: "state.form.is_enabled"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否允許加入",
      "label-for": "allow_join"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "name": "allow_join",
      "value": 1,
      "unchecked-value": 0
    },
    model: {
      value: _vm.state.form.allow_join,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "allow_join", $$v);
      },
      expression: "state.form.allow_join"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "類型",
      "label-for": "type"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "name": "type",
      "options": _vm.typeOptions
    },
    model: {
      value: _vm.state.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "type", $$v);
      },
      expression: "state.form.type"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "狀態",
      "label-for": "status"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "status",
      "type": "text"
    },
    model: {
      value: _vm.state.form.status,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "status", $$v);
      },
      expression: "state.form.status"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "起始日",
      "label-for": "start_at"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "start_at",
      "type": "date"
    },
    model: {
      value: _vm.state.form.start_at,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "start_at", $$v);
      },
      expression: "state.form.start_at"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "結束日",
      "label-for": "end_at"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "end_at",
      "type": "date"
    },
    model: {
      value: _vm.state.form.end_at,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "end_at", $$v);
      },
      expression: "state.form.end_at"
    }
  })], 1)], 1)])]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取消")]), _c('b-overlay', {
    staticClass: "d-inline-block",
    attrs: {
      "show": _vm.isSubmmiting,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "確認修改" : "確認新增") + " ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }